import { useCallback, useContext } from 'react';

import { SPAViewContext } from '@confluence/spa-view-context';
import { useSessionData } from '@confluence/session-data';

import { useLoomRecorderLoadingBlanket } from './useLoomRecorderLoadingBlanket';
import { useLoomEntryPointVariantState } from './useLoomEntryPointVariantState';

export const useTriggerCrossFlowSuccessCheck = () => {
	const { isSiteAdmin } = useContext(SPAViewContext);
	const [, { hideBlanket }] = useLoomRecorderLoadingBlanket();
	const [, { crossFlowSuccessCheck }] = useLoomEntryPointVariantState();
	const { cloudId } = useSessionData();

	const triggerCrossFlowSuccessCheck = useCallback(() => {
		// cross-flow would only be able to update the variant if the user is an admin
		// end-users get taken through request-trial flow, which does not provision Loom
		if (isSiteAdmin) {
			crossFlowSuccessCheck({ cloudId, hideBlanket });
		}
	}, [cloudId, isSiteAdmin, crossFlowSuccessCheck, hideBlanket]);

	return { triggerCrossFlowSuccessCheck };
};
